import store from "@/store";
import { canAccessRoute, isSystemAdministrator } from "@/utils/permissions";
import { canUseTraditionalLogin, canUseLtiLogin } from "@/constants/userRoles";

export function authGuard(to, from, next) {
  if (to.meta.isEmbed || to.path === "/definir-senha") return next();

  const publicPages = ["/", "/login", "/auth", "/definir-senha"];
  const authRequired = !publicPages.includes(to.path);
  const token = localStorage.getItem("token");

  const urlParams = new URLSearchParams(window.location.search);
  const hasAuthToken =
    urlParams.has("ltik") ||
    urlParams.has("token") ||
    urlParams.has("auth_token");

  if (hasAuthToken && to.path !== "/auth" && from.path !== "/auth" && to.path !== "/definir-senha") {
    return next({
      path: "/auth",
      query: to.query,
    });
  }

  if (authRequired && !token) {
    return next("/");
  }

  next();
}

export async function permissionGuard(to, from, next) {
  if (to.meta.isEmbed || to.path === "/definir-senha") return next();

  const token = localStorage.getItem("token");

  if (!token) {
    return next();
  }

  const isComingFromAuth = from.path === '/' || from.path === '/login' || from.path === '/auth';
  
  if (!store.state.auth.user && token && token !== "0" && !isComingFromAuth) {
    try {
      await store.dispatch("fetchUserData");
    } catch (error) {
      console.error(
        "[permissionGuard] Erro ao carregar dados do usuário:",
        error.message,
      );
    }
  }

  const routeName = to.name || to.path.replace("/", "");

  if (!canAccessRoute(routeName)) {
    console.warn(`[permissionGuard] Acesso negado à rota: ${routeName}`);
    return next("/home");
  }

  next();
}

export async function systemAdminGuard(to, from, next) {
  const token = localStorage.getItem("token");

  if (!token) {
    return next("/login");
  }

  if (!store.state.auth.user) {
    try {
      await store.dispatch("fetchUserData");
    } catch (error) {
      console.error("Erro ao carregar dados do usuário:", error);
      return next("/login");
    }
  }

  if (!isSystemAdministrator()) {
    console.warn("Acesso negado: requer administrador geral do sistema");
    return next("/home");
  }

  next();
}

export function loginTypeGuard(to, from, next) {
  const user = store.state.auth.user;

  if (user && to.path === "/login") {
    if (!canUseTraditionalLogin(user.codigo_perfil)) {
      console.warn("Este perfil não pode usar login tradicional");
      return next("/home");
    }
  }

  next();
}

export async function validateUserProfile(to, from, next) {
  const user = store.state.auth.user;

  if (!user) {
    return next();
  }

  if (from.path === "/auth" && !canUseLtiLogin(user.codigo_perfil)) {
    console.error("Perfil não autorizado para login via LTI");
    localStorage.removeItem("token");
    return next("/login");
  }

  if (from.path === "/login" && !canUseTraditionalLogin(user.codigo_perfil)) {
    console.error("Perfil não autorizado para login tradicional");
    localStorage.removeItem("token");
    return next("/");
  }

  next();
}
